import { IWebsiteWelcome } from '../../api-response/auth/website-builder';
import { WebsiteBuilderItemBase } from './website-builder-item-base';

export class WebsiteBuilderItemWelcome extends WebsiteBuilderItemBase {
    name = 'Top Banner';
    navName = 'Home';
    navLink = 'home';
    isPresent = true;
    isShowInMenu = true;
    isHomePagePart = true;

    sliderImage: string = null;
    sliderImageType: string = 'preset';
    headline: string = '';
    text: string = '';

    set value(item: IWebsiteWelcome) {
        this.isPresent = item.status;
        this.headline = item.headline || '';
        this.text = item.text || '';
        this.sliderImageType = item.imageType;
        this.sliderImage = item.imageUrl;
        this.priority = item.priority;
    }

    get value(): IWebsiteWelcome {
        return {
            text: this.text,
            headline: this.headline,
            imageType: this.sliderImageType,
            imageUrl: this.sliderImage,
            priority: this.priority
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-welcome.ts